import type { ReactNode } from 'react';
import styles from './Stat.module.css';

type Size = 'sm' | 'md' | 'lg';

type StatProps = {
  value: ReactNode;
  label: string;
  size?: Size;
  /** Override color on the value (e.g. for hero stat rows using --paper on dark). */
  valueColor?: string;
  /** Override color on the label (e.g. for stat rows on --ink-900 bg). */
  labelColor?: string;
  className?: string;
};

/**
 * Value + label pair. Used for hero stat strips (3 miles / 9:30 pace /
 * 28 min / RPE 4), session-detail rows, and summary cards.
 *
 * Value uses Instrument Serif + tabular-nums (.serif + .tnum utility
 * classes from global.css). Label is small-caps via a local rule.
 */
export function Stat({
  value,
  label,
  size = 'md',
  valueColor,
  labelColor,
  className,
}: StatProps) {
  return (
    <div className={[styles.stat, styles[size], className].filter(Boolean).join(' ')}>
      <div
        className={`${styles.value} serif tnum`}
        style={valueColor ? { color: valueColor } : undefined}
      >
        {value}
      </div>
      <div className={styles.label} style={labelColor ? { color: labelColor } : undefined}>
        {label}
      </div>
    </div>
  );
}
